var exports = {
  "FN": "createPane__jY0gSY",
  "aF": "createPaneContainer__pvmu4f",
  "cp": "avatarLink__9ZpOap",
  "my": "avatar__Nb3SD6",
  "y9": "chooseTemplateLink__xd4KFA",
  "Hy": "IssueCreatePageHeading__RZD_hL",
  "u$": "IssueCreatePageContainer__vKWINz",
};

module.exports = exports;
